import React, { useState } from "react";
import { Modal, Form, Checkbox, Button } from "antd";
import cancelX from "../../../../Assets/svg/cancelXbutton.svg";
import ExportButton from "../../../../Assets/svg/exportButton.svg";
import MessagePopUp from "../../../components/Messages/MessagePopUp";
import {
  exportToExcelTPMsummary,
} from "../../../components/ExportToExcel/exportToExcel";

// Convert camelCase to "Title Case With Spaces"
const formatCamelCase = (text) => {
  return text
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};

const ExportModal = ({ visible, onCancel, data }) => {
  const [form] = Form.useForm();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  const handleCheckboxChange = (checkedValues) => {
    setSelectedOptions(checkedValues);
  };

  const handleExport = () => {
    if (!data || !data.data) {
      console.error("No valid data to export.");
      return;
    }

    const columnMapping = {
      1: ["siteVisitsProgress", "redFlagsProgress"],
      2: ["activitySnapshot"],
      3: ["activityByLocation"],
      4: ["ipDonorReporting"],
      5: ["tasksOverviewResponse"],
    };

    const selectedSections = selectedOptions.flatMap(
      (option) => columnMapping[option]
    );

    const exportMapping = {
      siteVisitsProgress: data.data.siteVisitsProgress,
      redFlagsProgress: data.data.redFlagsProgress,
      activitySnapshot: data.data.activitySnapshot,
      activityByLocation: data.data.activityByLocation,
      ipDonorReporting: data.data.ipDonorReporting,
      tasksOverviewResponse: data.data.tasksOverviewResponse,
    };

    const rows = [];

    selectedSections.forEach((section) => {
      const sectionTitle = formatCamelCase(section);
      rows.push([sectionTitle]);

      const values = exportMapping[section];

      if (!values) {
        rows.push(["No data available"]);
      } else if (section === "ipDonorReporting") {
        rows.push(["Metric", "Value"]);
        rows.push(["Completed Field Team Reporting", values.completedFieldTeamReporting || 0]);
        rows.push(["Other Statuses Field Team Reporting", values.otherStatusesFieldTeamReporting || 0]);
        rows.push(["Awaiting Field Reportings", values.awaitingFieldReportings || 0]);
        rows.push(["Completed IP Donor Reports", values.completedIPDonorReports || 0]);

        rows.push([]); // Empty row for spacing

        rows.push(["IP Name", "Locations"]);
        if (Array.isArray(values.ipDonorReports) && values.ipDonorReports.length > 0) {
          values.ipDonorReports.forEach((report) => {
            rows.push([
              report.ipName || "N/A",
              report.locations
                ? report.locations.map((loc) => loc.name).join(", ")
                : "N/A",
            ]);
          });
        } else {
          rows.push(["No reports available"]);
        }

      } else if (typeof values === "object" && !Array.isArray(values)) {
        rows.push(["Metric", "Value"]);
        Object.entries(values).forEach(([key, value]) => {
          rows.push([formatCamelCase(key), value]);
        });
      } else if (Array.isArray(values) && values.length > 0) {
        rows.push(["IP Name", "Locations"]);
        values.forEach((item) => {
          rows.push([
            item.ipName || "N/A",
            item.locations ? item.locations.map((loc) => loc.name).join(", ") : "N/A",
          ]);
        });
      }

      rows.push([]);
    });

    exportToExcelTPMsummary(rows, "TPM-Summary");
  };

  const handleClose = () => {
    setSelectedOptions([]);
    onCancel();
  };

  return (
    <Modal
      open={visible}
      closable={false}
      footer={null}
      width={600}
      onCancel={handleClose}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
        }}
      >
        <img
          src={cancelX}
          style={{ marginLeft: "auto", cursor: "pointer" }}
          onClick={handleClose}
        />
      </div>

      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />

      <h2 className="modalHeader">Export dashboard</h2>

      <Form form={form} layout="vertical" className="p-3">
        <Form.Item
          name="exportOptions"
          label={
            <p
              style={{
                fontFamily: "Poppins",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "22px",
              }}
            >
              Please select the sections you want to export
            </p>
          }
        >
          <Checkbox.Group
            onChange={handleCheckboxChange}
            className="d-flex flex-column gap-2"
          >
            <Checkbox className="exportCheckbox" value="1">
              Site Visits progress and Red Flags Progress
            </Checkbox>
            <Checkbox className="exportCheckbox" value="2">
              Activity Snapshot
            </Checkbox>
            <Checkbox className="exportCheckbox" value="3">
              Activity by Location
            </Checkbox>
            <Checkbox className="exportCheckbox" value="4">
              IP/Donor Reporting Status Snapshot
            </Checkbox>
            <Checkbox className="exportCheckbox" value="5">
              Tasks Overview
            </Checkbox>
          </Checkbox.Group>
        </Form.Item>

        <div className="buttonsModal" style={{ marginTop: "32px" }}>
          <Button className="inviteButtonTPM" key="cancel" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            className="addButtonTPM"
            key="submit"
            type="primary"
            onClick={handleExport}
            icon={<img src={ExportButton} alt="exportIcon" />}
            loading={loading}
          >
            Export selected sections
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ExportModal;
